/** A failed search can still have usable results from another source. */
export class SearchResultsError<T> extends Error {
  constructor(
    message: string,
    readonly results: T[]
  ) {
    super(message)
    this.name = 'SearchResultsError'
  }
}
